import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, Sparkles } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICE_PREVIEWS } from "../mock";

const Footer = () => {
  const waLink = `https://wa.me/${COMPANY.whatsappRaw}?text=${encodeURIComponent(
    COMPANY.whatsappMsg
  )}`;

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img
              src={COMPANY.logo}
              alt="WBL Services"
              className="mb-4 h-20 w-auto rounded-lg bg-white p-2"
            />
            <p className="mb-3 text-sm font-semibold text-sky-400">
              30 ans d'expérience
            </p>
            <p className="text-sm leading-relaxed text-slate-400">
              Entreprise de nettoyage professionnelle à Toulouse. Pour les
              particuliers et les professionnels exigeants.
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">
              Navigation
            </h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-sm text-slate-400 transition-colors hover:text-sky-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">
              Services
            </h4>
            <ul className="space-y-2.5">
              {SERVICE_PREVIEWS.map((s) => (
                <li key={s.title}>
                  <Link
                    to="/services"
                    className="text-sm text-slate-400 transition-colors hover:text-sky-400"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${COMPANY.phoneRaw}`}
                  className="flex items-center gap-3 text-sm text-slate-400 transition-colors hover:text-sky-400"
                >
                  <Phone size={16} className="text-sky-400" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a
                  href={waLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-sm text-slate-400 transition-colors hover:text-sky-400"
                >
                  <MessageCircle size={16} className="text-sky-400" /> {COMPANY.whatsapp}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="flex items-center gap-3 text-sm text-slate-400 transition-colors hover:text-sky-400"
                >
                  <Mail size={16} className="text-sky-400" /> {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-400">
                <MapPin size={16} className="mt-0.5 shrink-0 text-sky-400" />
                {COMPANY.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-8 md:flex-row">
          <p className="text-xs text-slate-500">
            © 2026 WBL Services — Tous droits réservés. Toulouse · France
          </p>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-full bg-green-500 px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-green-600"
          >
            <MessageCircle size={16} /> WhatsApp · réponse rapide {COMPANY.whatsapp}
          </a>
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="https://alpenpro.agency/"
            target="_blank"
            rel="noopener noreferrer"
            className="animate-badge-pulse group inline-flex items-center gap-2 rounded-full border border-sky-500/40 bg-sky-500/10 px-5 py-2.5 transition-all duration-300 hover:border-sky-400 hover:bg-sky-500/20"
          >
            <Sparkles size={16} className="text-sky-400 transition-transform duration-300 group-hover:rotate-12" />
            <span className="text-sm font-semibold text-slate-400">Réalisé par</span>
            <span className="animate-attention text-sm font-extrabold text-sky-400">
              Alpen Pro Agency
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
